<template>
  <el-menu class="navbar" mode="horizontal">
    <!-- <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger> -->
    <!-- <breadcrumb></breadcrumb>  -->
    <router-link to="/">
      <!-- <img class="navbar-logo" :src="logo"  > -->
      <img src="" alt="">
    </router-link>
    <!-- <el-input
      class="navbar-input"
      suffix-icon="el-icon-search"
      v-model="input2">
    </el-input>
    <div class="navber-word">
      <svg-icon icon-class="help" id="total-icon"></svg-icon>
    </div>
    <div class="navber-issue">
      <el-dropdown trigger="click">
        <el-badge  class="item">
          <svg-icon icon-class="hint" id="total-icon"></svg-icon>
        </el-badge>
        <el-dropdown-menu slot="dropdown" class="navbar-tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="系统更新 (6)" name="first">
              <div class="nb-ul">
                <div class="nb-li">
                  <div class="nb-li-color"></div>
                  <div class="nb-li-list">
                    <div class="nb-li-list-main">重要更新：修复一些已知问题，提升使用性能</div>
                    <div class="nb-li-list-time">2019-05-27  16:13:10</div>
                  </div>
                </div>
              </div>
              <div class="nb-btn">
                <div class="nb-btn-clear">清除通知</div>
                <div class="nb-btn-more">查看更多</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="广告 (2)" name="second">配置管理</el-tab-pane>
          </el-tabs>
        </el-dropdown-menu>
      </el-dropdown>

    </div> -->

<!--    <a style="color: red;font-size: 15px;padding-left: 30px">通知：国网支付方式已修复，后续出现问题可群里艾特、电话或者私聊我</a>-->
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" src="../../../assets/images/logo.png"> -->
        <img src="" alt="">
        (紧急)技术服务：
          <div style="color: red">
            15139170872(微信同号)
          </div>

        <span class="user-name">{{ username }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/" index="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import logo from '@/assets/images/logo.png';
import {outLogin} from '../../../api/login';

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
      logos: '../../../assets/images/logo.png',
      input2: '',
      logo,
      activeName: 'first',
      username: '',
    }
  },
  created() {
    this.username = localStorage.getItem("account")
  },
  methods: {
    // toggleSideBar() {
    //   this.$store.dispatch('ToggleSideBar')
    // },
    logout() {
      outLogin(localStorage.getItem('account')).then(res => {
        if (res.data.message == 'SUCCESS') {
          this.$store.dispatch('LogOut').then(() => {
            localStorage.clear()
            sessionStorage.clear()
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }
      })

    },
    handleClick(tab, event) {

    },
    toHome() {
      this.$router.push({path: '/home'})
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.avatar-wrapper img:hover {
  transform: rotate(666turn); //定义了transform的2d旋转，turn表示 圈(单位) 。
  transition-duration: 59s; //定义了执行时间。
  transition-timing-function: cubic-bezier(.34, 0, .84, 1) //定义执行速度
}

.navbar {
  height: 64px;
  border-radius: 0px !important;
  display: flex;
  align-items: center;

  .navbar-logo {
    width: 57px;
    height: 30px;
    margin-left: 29px;
    cursor: pointer;

    img {
      width: 57px;
      height: 30px;
    }
  }

  .navbar-input {
    position: absolute;
    right: 332px;
    width: 260px;

    .el-input__inner {
      border-radius: 30px;
      background-color: #F5F7FA;
      border: 0;
      padding-right: 52px;
    }

    .el-input__suffix {
      right: 30px;
      color: #333333;
      font-size: 22px;
    }
  }
  .navber-issue {
    position: absolute;
    right: 194px;
  }

  .navber-word {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 253px;
  }

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 30px;
    line-height: 50px;

    .user-name {
      margin-left: 13px;
      margin-right: 9px;
    }

    .avatar-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      .user-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .el-icon-caret-bottom {
        // position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }

  #total-icon {
    width: 22px;
    height: 22px;
  }

  .navbar-tab {
    width: 300px;
    height: 380px;
  }

  #tab-first {
    margin-left: 60px
  }

  .el-tabs__active-bar {
    left: 60px;
  }

  .nb-ul {
    width: 100%;
    height: 261px;
  }

  .el-dropdown-menu {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .nb-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 19px;
  }

  .nb-li-color {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #40A9FF;
    margin-left: 20px;
    margin-right: 10px;
    margin-top: 4px;
  }

  .nb-li-list-main {
    font-size: 14px;
    color: #606266;
    padding-right: 28px;
  }

  .nb-li-list-time {
    font-size: 12px;
    color: #909399;
    margin-top: 9px;
  }

  .nb-btn {
    display: flex;
    margin-top: 11px;
  }

  .nb-btn-clear {
    width: 149px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #606266;
    font-size: 14px;
    border-right: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }

  .nb-btn-more {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #606266;
    font-size: 14px;
    border-top: 1px solid #EBEEF5;
  }
}

</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue